import React, {Component} from 'react';
import { BrowserRouter, Switch, Link, Route } from 'react-router-dom';
import ConfirmOrderContent, {AppWithRouter} from '../components/ConfirmOrderContent'; 
import axios from 'axios'; 

import Header from '../common/Header'; 
import Footer from '../common/Footer';
import PageHeader from '../components/PageHeader'; 
 
class ConfirmOrder extends React.Component{

    constructor(){
        super(); 
    }
 
    render()
    {
       
        return (
            <div className="page-wrapper">
                <Header/> 
                <PageHeader title="Confirm Order"/>
                <AppWithRouter/>  
                <Footer/>
            </div>
       
        )
    }

}
export default ConfirmOrder;